import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import CompanyDocumentEntry from './CompanyDocumentEntry';
import NewBadge from './NewBadge';
import { CompanyInfoSection } from './styled';

const CompanyCertificate: React.FunctionComponent = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );
  const { certicateList } = useStyles();

  if (!context) return null;

  const { partnerInfo } = context;

  const certifications = [...(partnerInfo?.certifications ?? [])].reverse();
  const noCertifications = certifications.length === 0;

  if (noCertifications) return null;

  return (
    <CompanyInfoSection id="certificate">
      <div className="section-title new-column">
        <div className="new-column">
          <CustomizedTypography>인증</CustomizedTypography>
          <NewBadge />
        </div>
      </div>
      <div className={certicateList}>
        {noCertifications && (
          <CustomizedTypography className="no-data">
            업데이트 예정
          </CustomizedTypography>
        )}
        {certifications.map((certificate) => (
          <CompanyDocumentEntry
            certificate={certificate}
            key={certificate.id}
          />
        ))}
      </div>
    </CompanyInfoSection>
  );
};

export default CompanyCertificate;

const useStyles = makeStyles((theme) => ({
  certicateList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(1, 1fr)'
    }
  }
}));
